module.exports = __webpack_public_path__ + "img/logo_blue_1.4dcb19c6.png";